import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Vor Ort',
      [RoomServiceLocationType.TableService]: 'Vor Ort',
      both: 'Vor Ort',
    },
    [ORDER_METHODS.PICKUP]: 'Abholung',
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
  },
};
